import React from "react";

const InstagramFloating = () => {
  return (
    <div className="fixed right-5 bottom-40 lg:bottom-28 z-20 ">
      <div className="absolute inset-0 flex justify-center items-center">
        <span className="absolute inline-flex w-full h-full rounded-full bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 opacity-75 animate-ping"></span>
      </div>
      <a
        href="https://www.instagram.com/scanglobalrealty?igsh=djk0ZHYxbXIwaWdm"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit Instagram"
        className="relative w-12 h-12 rounded-full flex justify-center items-center shadow-lg text-white 
                   bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600
                   hover:opacity-85 transition-all duration-300 ease-out group hover:scale-105 active:scale-95"
      >
        <svg
          viewBox="0 0 24 24"
          className="w-7 h-7"
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 2.2c3.2 0 3.584.012 4.85.07 1.17.055 1.97.24 2.43.405a4.9 4.9 0 0 1 1.76 1.01 4.9 4.9 0 0 1 1.01 1.76c.165.46.35 1.26.405 2.43.058 1.266.07 1.65.07 4.85s-.012 3.584-.07 4.85c-.055 1.17-.24 1.97-.405 2.43a4.9 4.9 0 0 1-1.01 1.76 4.9 4.9 0 0 1-1.76 1.01c-.46.165-1.26.35-2.43.405-1.266.058-1.65.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.055-1.97-.24-2.43-.405a4.9 4.9 0 0 1-1.76-1.01 4.9 4.9 0 0 1-1.01-1.76c-.165-.46-.35-1.26-.405-2.43C2.212 15.584 2.2 15.2 2.2 12s.012-3.584.07-4.85c.055-1.17.24-1.97.405-2.43a4.9 4.9 0 0 1 1.01-1.76A4.9 4.9 0 0 1 5.445 2.7c.46-.165 1.26-.35 2.43-.405C8.416 2.212 8.8 2.2 12 2.2zm0 1.8c-3.16 0-3.524.01-4.77.068-1.026.05-1.584.218-1.954.362a3.1 3.1 0 0 0-1.13.735 3.1 3.1 0 0 0-.735 1.13c-.144.37-.312.928-.362 1.954-.058 1.246-.068 1.61-.068 4.77s.01 3.524.068 4.77c.05 1.026.218 1.584.362 1.954.175.45.425.856.735 1.13.37.313.78.56 1.13.735.37.144.928.312 1.954.362 1.246.058 1.61.068 4.77.068s3.524-.01 4.77-.068c1.026-.05 1.584-.218 1.954-.362a3.1 3.1 0 0 0 1.13-.735 3.1 3.1 0 0 0 .735-1.13c.144-.37.312-.928.362-1.954.058-1.246.068-1.61.068-4.77s-.01-3.524-.068-4.77c-.05-1.026-.218-1.584-.362-1.954a3.1 3.1 0 0 0-.735-1.13 3.1 3.1 0 0 0-1.13-.735c-.37-.144-.928-.312-1.954-.362-1.246-.058-1.61-.068-4.77-.068zm0 3.8a5.2 5.2 0 1 1 0 10.4 5.2 5.2 0 0 1 0-10.4zm0 1.8a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8zm6.4-1.9a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z" />
        </svg>

        <span className="absolute inset-0 rounded-full border-4 border-white/30 animate-pulse" />

        <div className="absolute right-full mr-3 invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-300 whitespace-nowrap">
          <div className="bg-gradient-to-r from-white via-slate-200 to-white font-medium text-slate-900 text-sm px-3 py-1 rounded shadow-lg">
            Follow us on Instagram
          </div>
          <div className="absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 rotate-45 w-2 h-2 bg-white" />
        </div>
      </a>
    </div>
  );
};

export default InstagramFloating;
